import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M43.4376 16.1675C36.1756 1.23261 25.1543 1.74414 24.3353 1.80432C23.5164 1.8645 12.4951 1.23261 5.28241 16.1675C-1.23959 29.658 1.45407 60.1696 5.59816 70.0393C10.1271 80.8618 18.8494 89.7886 24.3452 89.7886C29.8411 89.7886 38.5535 80.8618 43.0923 70.0393C47.2561 60.1696 49.9892 29.6981 43.4376 16.1675Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
